module.exports = __webpack_public_path__ + "static/media/school_task_auth_bg.1632f651.png";